module.exports = __webpack_public_path__ + "img/riskOrange.9cb56f1a.png";